import ChevronRight from "@/components/icons/chevron_right";
import { ModuleColumn } from "@/components/module";
import { useI18n } from "next-localization";
import Image from "next/image";

const resources: Array<{
  source: string;
  image: string;
  url: string;
  title: string;
  body: string;
}> = [
  {
    source: "Watershed",
    image: "/favicon.svg",
    url: "https://watershed.com/blog/carbon-removal-and-offsets-a-buyers-guide",
    title: "Carbon removal and offsets: a buyer’s guide",
    body: "Our introductory guide on the topic",
  },
  {
    source: "Shopify",
    image: "/img/testimonials/shopify.svg",
    url: "https://www.shopify.com/about/environment/sustainability-fund",
    title: "Shopify’s $5M Sustainability Fund",
    body: "A top-tier CDR commitment from one of our customers",
  },
  {
    source: "Stripe",
    image: "https://logo.clearbit.com/stripe.com",
    url: "https://stripe.com/climate",
    title: "Stripe Climate",
    body: "Embedding CDR funding into business models at scale",
  },
  {
    source: "CDR Primer",
    image: "https://logo.clearbit.com/cdrprimer.org",
    url: "https://cdrprimer.org/",
    title: "Carbon Dioxide Removal Primer",
    body: "A comprehensive guide to all things carbon removal",
  },
];

export default function RemovalPrimerModule() {
  const { t } = useI18n();
  return (
    <ModuleColumn
      headline="Understanding frontier carbon removal"
      className="module-removal-primer"
    >
      <p style={{ marginBottom: "auto" }}>
        Permanent carbon dioxide removal (CDR) has quickly become a core
        component of running a high-impact climate {t("common.program")}. If
        you’re new to CDR, here are some resources to get you started.
      </p>
      <ol>
        {resources.map((milestone) => (
          <li key={milestone.url}>
            <a href={milestone.url} target="_blank" rel="noopener noreferrer">
              <Image
                width={128}
                height={128}
                src={milestone.image}
                alt={milestone.source}
                className="logo"
              />
              <div>
                <strong>{milestone.title}</strong>
                <p>{milestone.body}</p>
              </div>
              <ChevronRight />
            </a>
          </li>
        ))}
      </ol>
      <style jsx global>{`
        section.module-removal-primer {
          background-color: var(--module-color-hover);
        }
        section.module-removal-primer .padded-box {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
      `}</style>
      <style jsx>{`
        ol {
          margin: 24px -16px 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 16px;
          list-style: none;
        }
        li {
          width: 100%;
          border-radius: 16px;
          padding: 0;
          margin: 0;
          overflow: hidden;
          line-height: 1.375;
        }
        li a {
          background-color: #fff;
          transition: 0.125s background-color ease-in-out;
          padding: 16px;
          display: grid;
          grid-template-columns: 48px 1fr auto;
          align-items: center;
          column-gap: 12px;
          text-decoration: none;
          font-weight: initial;
        }
        @media screen and (min-width: 520px) {
          ol {
            margin-bottom: -8px;
          }
          li {
            column-gap: 16px;
          }
        }
        li a:hover,
        li a:focus {
          background-color: #f0f3f7;
        }
        li strong {
          color: initial;
        }
        li :global(.logo) {
          width: 64px;
          height: 64px;
          border-radius: 12px;
          overflow: hidden;
        }
      `}</style>
    </ModuleColumn>
  );
}
